import { tAgendaProviderProps } from '../Agenda.types';
import useAgenda from '../hooks/agenda.hook';
import { AgendaContext } from './agenda.context';

export function AgendaProvider(props: tAgendaProviderProps) {
  const agenda = useAgenda();

  return (
    <AgendaContext.Provider value={agenda}>
      {props.children}
    </AgendaContext.Provider>
  );
}
